import React from "react";
import { connect } from "react-redux";

import { Button } from "@material-ui/core";
import { Edit as EditIcon } from "@material-ui/icons";

import CustomerLeadCRM from "../../../../components/Tables/CustomerLeadCRM";
//store
import * as actions from "../../../../store/actions/actionIndex";

function EditConferenceCrm(props) {
	const [editLead, setEditLead] = React.useState(0);

	const handleClickOpen = () => {
		setEditLead(props.leadId);
		props.onGetCustomerDetails(props.agentId, props.campaignId, props.leadId, "passive");
	};

	const unSetLead = () => {
		setEditLead(0);
	};

	return (
		<div style={{ marginInlineStart: "12px" }}>
			<Button variant="outlined" size="small" title="Edit" onClick={handleClickOpen} style={{ color: "#aaa", padding: "0px", minWidth: "auto" }}>
				<EditIcon />
			</Button>
			{editLead ? <CustomerLeadCRM leadId={editLead} unSetLead={unSetLead} /> : ""}
		</div>
	);
}

const mapStateToProps = (state) => {
	return {
		error: state.agentDial.error,
		loading: state.agentDial.loading,
		leadError: state.customerDetails.error,
		leadLoading: state.customerDetails.loading,
		agentState: state.agentData.agentState,
		agentId: state.agentData.agentId,
		facilityConf: state.agentConfig.facilityConf,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onGetCustomerDetails: (agentId, campaignId, leadId, leadType) => dispatch(actions.getCustomerDetails(agentId, campaignId, leadId, leadType)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(EditConferenceCrm);
